import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Mask, Button, ButtonArea, CellsTitle, Form, FormCell, CellBody, CellFooter, Switch} from 'react-weui';
import axios from 'axios';
import qs from 'qs'


import '../../styles/classroom/ClassroomOptions.css';


class ClassroomOptions extends Component{
	constructor(){
		super();
		this.onRequestClose = this.onRequestClose.bind(this);
		this.onSwitchSpeak = this.onSwitchSpeak.bind(this);
		this.onSwitchDiscuss = this.onSwitchDiscuss.bind(this);
		this.onSwitchReward = this.onSwitchReward.bind(this);
	}

	setOption(name, value){
		const {dispatch} = this.props;
		const data = {
			options: JSON.stringify({
				[name]: value
			})
		}
		axios.post('/api/classroom/' + this.props.lecture.id + '/set_option', qs.stringify(data)).then((response) => {
			if(response.data.code === 0){
				dispatch({
					type: 'CLASSROOM_SET_OPTION',
					payload: response.data.data.options
				})
			}
		}).catch((error) => {
			dispatch({
				type: 'CLASSROOM_SET_OPTION',
				payload: {
					[name]: value
				}
			})
		});
	}

	onSwitchDiscuss(){
		const {options} = this.props;

		if (options.can_discuss) {
			this.props.dispatch({type: 'CLASSROOM_HIDE_DISCUSS_LIST_AREA'})
		} else {
			this.props.dispatch({type: 'CLASSROOM_SHOW_DISCUSS_LIST_AREA'})
		}
		this.setOption('can_discuss', !options.can_discuss);
	}

	onSwitchSpeak(){
		const {options} = this.props;
		this.setOption('can_speak', !options.can_speak);
	}

	onSwitchReward(){
		const {options} = this.props;
		this.setOption('can_reward', !options.can_reward);
	}

	onRequestClose(){
		this.props.dispatch({
			type: 'CLASSROOM_HIDE_OPTIONS'
		})
	}

	render(){
		const {options, showOptions} = this.props;
		if(!showOptions){
			return null;
		}
		return (<div className="classroom-options">
			<Mask onClick={this.onRequestClose} />
			<div className="content">
			    <CellsTitle>设置</CellsTitle>
	            <Form>
	                <FormCell switch>
	                    <CellBody>允许用户评论</CellBody>
	                    <CellFooter>
	                        <Switch onChange={this.onSwitchDiscuss} checked={options.can_discuss} />
	                    </CellFooter>
	                </FormCell>
	                <FormCell switch>
	                    <CellBody>显示打赏消息</CellBody>
	                    <CellFooter>
	                        <Switch onChange={this.onSwitchReward} checked={options.can_reward} />
	                    </CellFooter>
	                </FormCell>
	            </Form>
	            <ButtonArea>
	           		<Button type="primary" onClick={this.onRequestClose}>确定</Button>
	            </ButtonArea>
			</div>
		</div>)
	}
}


export default connect((state) => ({
	options: state.classroom.options,
	showOptions: state.classroom.showOptions,
	lecture: state.classroom.lecture
}))(ClassroomOptions)




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomOptions.js